const removeHtmlTagsFromString = (s) => s.replace(/(<([^>]+)>)/gi, '');

export default removeHtmlTagsFromString;
